// src/crm/hooks/useAttachments.ts
import { useQuery } from '@tanstack/react-query'
import type { Attachment } from '../../lib/types'

/** Upload binaire d'une pièce jointe via en-têtes X-* */
export async function uploadAttachment(opts: {
  file: File;
  kind: Attachment['kind'];
  linkedType: Attachment['linkedType'];
  linkedId: string;
}): Promise<Attachment> {
  const res = await fetch('/api/attachments', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': opts.file.type || 'application/octet-stream',
      'Content-Length': String(opts.file.size),
      'X-Filename': opts.file.name,
      'X-Kind': opts.kind,
      'X-Linked-Type': opts.linkedType,
      'X-Linked-Id': opts.linkedId,
    },
    body: opts.file,
    // @ts-expect-error requis par fetch streaming
    duplex: 'half',
  });
  if (!res.ok) {
    const err = await res.json() as { error: { message: string } };
    throw new Error(err.error.message);
  }
  const data = await res.json() as { attachment: Attachment };
  return data.attachment;
}

/** Liste les pièces jointes pour un linked_type/linked_id donné */
export function useAttachments(linkedType: Attachment['linkedType'], linkedId: string | null) {
  return useQuery<Attachment[]>({
    queryKey: ['attachments', linkedType, linkedId],
    queryFn: () =>
      fetch(`/api/attachments?linkedType=${linkedType}&linkedId=${linkedId}`, {
        credentials: 'include',
        headers: { Accept: 'application/json' },
      })
        .then((r) => r.json() as Promise<{ attachments: Attachment[] }>)
        .then((r) => r.attachments),
    enabled: linkedId !== null,
  });
}
